import { getSectionId, isDemographicSection, isInterestSection } from '@/services/targetingInfo';
import { SECTION_CODES } from '@/constants';

function createPercentageCalculator(filter) {
  return (state) => {
    const data = Object.entries(state.data)
      .filter(([key]) => filter(key))
      .map(([, value]) => value)
      .filter(Boolean);

    const displayData = state.displayData.filter(({ parentCode }) => filter(parentCode));

    return parseInt((data.length / displayData.length) * 100, 10) || 0;
  };
}

export default {
  targetingInfoDisplayData(state) {
    return state.displayData;
  },
  targetingInfoDisplayDataByPriority(state) {
    return [...state.displayData].sort((a, b) => a.priority - b.priority);
  },
  targetingInfoDemographicData(state, getters) {
    function isEmptyValue(item) {
      return !getters.targetingInfoData[getSectionId(item)];
    }

    return getters.targetingInfoDisplayDataByPriority
      .filter(({ parentCode }) => isDemographicSection(parentCode))
      .sort((a, b) => isEmptyValue(b) - isEmptyValue(a));
  },
  targetingInfoInterestData(state, getters) {
    return getters.targetingInfoDisplayDataByPriority.filter(({ parentCode }) =>
      isInterestSection(parentCode),
    );
  },
  fillPercentage(state) {
    const IGNORE_SECTIONS = [SECTION_CODES.COUNTRY, SECTION_CODES.TEST_ACCOUNT];
    return createPercentageCalculator(
      (key) => !IGNORE_SECTIONS.includes(key) && isDemographicSection(key),
    )(state);
  },
  fillPercentageInterests(state) {
    return createPercentageCalculator((key) => isInterestSection(key))(state);
  },
  targetingInfoData(state) {
    return state.data;
  },
  containsTargetingDataToSave(state) {
    return !!Object.keys(state.data).length;
  },
  hasSavedTargetingData(state) {
    return !!state.userSegments.length;
  },
  showDataFillingHint(state) {
    return state.showDataFillingHint;
  },
};
